import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrDeviceFieldAggrResponse } from '@/api/routes/stat/types';

import { fetchStaticAggrDeviceSumFieldAggr } from '../actionCreators';

interface InitialState {
  aggrBySumField: AggrDeviceFieldAggrResponse,
  prevAggrBySumField: AggrDeviceFieldAggrResponse,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  aggrBySumField: [],
  prevAggrBySumField: [],
  isLoading: false,
  error: '',
};

export const staticAggrDeviceBySumFieldSlice = createSlice({
  name: 'aggrStaticDeviceBySumField',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchStaticAggrDeviceSumFieldAggr.fulfilled.type]: (state, action: PayloadAction<AggrDeviceFieldAggrResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.prevAggrBySumField = state.aggrBySumField;
      state.aggrBySumField = action.payload;
    },
    [fetchStaticAggrDeviceSumFieldAggr.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchStaticAggrDeviceSumFieldAggr.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default staticAggrDeviceBySumFieldSlice.reducer;
